import React from 'react';
import { GrcButton, GrcButtonType } from '@grc/ui-package';
import { useI18nState } from '../stores/settings/language-context';

// Exactly one way on: "Try again", or (access_denied) only a logout back to the login page.
type AuthErrorProps = { errorMessage?: string } & (
  | { onRetry: () => void; onBackToLogin?: never }
  | { onBackToLogin: () => void; onRetry?: never }
);

// Sign-in could not be completed: an Auth0 error, or, with no error message, the loop guard
// stopped the automatic login redirects.
const AuthError = ({
  errorMessage,
  onRetry,
  onBackToLogin
}: AuthErrorProps) => {
  const { localeData } = useI18nState();

  return (
    <div
      data-testid="auth_error"
      className="auth-error-screen d-flex flex-column justify-content-center align-items-center vh-100"
    >
      <h4>{localeData.SignInFailed}</h4>
      <p>{errorMessage ?? localeData.SignInRedirectLoop}</p>
      {onBackToLogin ? (
        <GrcButton
          id="auth_error_back_to_login"
          text={localeData.BackToLogin}
          className="grc-btn-primary"
          type={GrcButtonType.Normal}
          onClick={onBackToLogin}
        />
      ) : (
        <GrcButton
          id="auth_error_try_again"
          text={localeData.TryAgain}
          className="grc-btn-primary"
          type={GrcButtonType.Normal}
          onClick={onRetry}
        />
      )}
    </div>
  );
};

export default AuthError;
